"use client";
import { styled } from "@mui/material/styles";
import { SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const ResponsiveContainer = styled(CostcoBox)(() => {
  return {
    display: "flex",
    gap: SpaceLg,
    width: "100%",
    "@container (max-width: 768px)": {
      flexDirection: "column"
    }
  };
});
export {
  ResponsiveContainer
};
